'use strict';

{
  {
    /*====================================================
    Onepiece Slider
    ====================================================*/
    // 9個のスライダーを初期化
    for (let i = 1; i <= 9; i++) {
      const target = `.coordinate__slider${i}`;
      const options = {
        type: 'loop',
        speed: 800,
        perPage: 1,
        pagination: false,
      };
      const splide = new Splide(target, options);
      splide.mount();
    }
  }

  {
    // coordinate.js
    document.addEventListener('DOMContentLoaded', function () {
      // スクロール復元を手動に設定
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      const hash = window.location.hash;
      if (!hash) {
        document.body.classList.add('is-loaded');
        return;
      }

      const target = document.querySelector(hash);
      const header = document.querySelector('.header');

      if (target && header) {
        // Splide内の画像とwindowロードの完了を待つ
        const sliderImages = document.querySelectorAll('.coordinate__slide_item_image');

        // 画像の読み込み完了を監視するPromiseの配列を作成
        const imagePromises = Array.from(sliderImages).map(img => {
          return new Promise(resolve => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = () => resolve();
              // エラー時も resolve して処理を継続
              img.onerror = () => resolve();
            }
          });
        });

        // window.loadイベントを待つPromise
        const windowLoadPromise = new Promise(resolve => {
          if (document.readyState === 'complete') {
            resolve();
          } else {
            window.addEventListener('load', resolve);
          }
        });

        // すべての画像とwindowロードの完了を待つ
        Promise.all([windowLoadPromise, ...imagePromises]).then(() => {
          // 少し遅延を入れて実行（念のため）
          setTimeout(() => {
            // 複数の方法でヘッダーの高さを取得
            const headerStyles = window.getComputedStyle(header);
            const headerHeight = Math.max(header.offsetHeight, header.getBoundingClientRect().height, header.clientHeight, parseFloat(headerStyles.height));

            // 現在のスクロール位置を考慮した絶対位置の計算
            const rect = target.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop;
            const offsetPosition = targetPosition - headerHeight;

            // スクロール位置を設定
            window.scrollTo({
              top: offsetPosition,
              behavior: 'instant',
            });

            // 最終確認と微調整
            setTimeout(() => {
              const finalRect = target.getBoundingClientRect();
              const finalHeaderStyles = window.getComputedStyle(header);
              const finalHeaderHeight = Math.max(header.offsetHeight, header.getBoundingClientRect().height, header.clientHeight, parseFloat(finalHeaderStyles.height));

              if (Math.abs(finalRect.top - finalHeaderHeight) > 1) {
                window.scrollTo({
                  top: window.pageYOffset + (finalRect.top - finalHeaderHeight),
                  behavior: 'instant',
                });
              }

              // ローディング終了
              document.body.classList.add('is-loaded');
            }, 50);
          }, 100);
        });
      } else {
        // ターゲットが見つからない場合はすぐにローディングを終了
        document.body.classList.add('is-loaded');
      }
    });
  }
}
